export default {
  // App
  "appTitle": "多機能タイマーとストップウォッチ",
  "siteIntro": "カスタムタイマーとストップウォッチを様々な視覚効果と通知で作成・管理",
  
  // General
  "cancel": "キャンセル",
  "save": "保存",
  "start": "開始",
  "pause": "一時停止",
  "stop": "停止",
  "reset": "リセット",
  "add": "追加",
  "edit": "編集",
  "delete": "削除",
  "confirm": "確認",
  "close": "閉じる",
  "back": "戻る",
  "submit": "送信",
  "timer": "タイマー",
  "optional": "任意",
  "clickAgainToDelete": "もう一度クリックして削除",
  "fullscreen": "全画面表示",
  "exitFullscreen": "全画面表示を終了",
  
  // Timer modes
  "countdown": "カウントダウン",
  "stopwatch": "ストップウォッチ",
  
  // TimersContainer
  "myTimers": "マイタイマー",
  "addTimer": "タイマーを追加",
  "noTimers": "タイマーはまだありません",
  "createFirstTimer": "最初のタイマーを作成しましょう",
  
  // TimerForm
  "createTimer": "タイマーを作成",
  "editTimer": "タイマーを編集",
  "timerName": "タイマー名",
  "timerNamePlaceholder": "タイマーの名前を入力してください",
  "timerMode": "タイマーモード",
  "duration": "時間",
  "hours": "時間",
  "minutes": "分",
  "seconds": "秒",
  "showMilliseconds": "ミリ秒を表示",
  
  // Settings
  "settings": "設定",
  "darkMode": "ダークモード",
  "language": "言語",
  "notificationSound": "通知音",
  "enableNotifications": "通知を有効にする",
  "english": "英語",
  "chinese": "中国語",
  "spanish": "スペイン語",
  "french": "フランス語",
  "japanese": "日本語",
  
  // Notification sounds
  "default": "デフォルト",
  "bell": "ベル",
  "digital": "デジタル",
  "chime": "チャイム",
  "none": "なし",
  
  // Messages
  "timerComplete": "タイマー完了！",
  
  // Effects
  "effect": "エフェクト",
  "effectSettings": "エフェクト設定",
  "effectType": "エフェクトタイプ",
  "opacity": "不透明度",
  "speed": "速度",
  "primaryColor": "メインカラー",
  "secondaryColor": "サブカラー",
  "circle": "サークル",
  "wave": "ウェーブ",
  "pulse": "パルス",
  "particles": "パーティクル",
  "gradient": "グラデーション",
  "ripple": "リップル",
  
  // About page
  "about": "アプリについて",
  "aboutTitle": "このアプリについて",
  "aboutIntroTitle": "多機能タイマーとストップウォッチへようこそ",
  "aboutIntroText": "このウェブアプリでは、複数のカスタマイズ可能なタイマーとストップウォッチを作成・管理できます。運動、料理、作業時間など、さまざまな用途に柔軟で使いやすいツールを提供します。",
  
  "aboutFeaturesTitle": "主な機能",
  "aboutFeatureTimersTitle": "タイマーとストップウォッチ",
  "aboutFeatureTimersText": "カウントダウンタイマーとストップウォッチの両方を作成できます。カウントダウンタイマーは時間、分、秒を設定でき、ストップウォッチはゼロからの経過時間を測定します。",
  
  "aboutFeatureNotificationsTitle": "通知",
  "aboutFeatureNotificationsText": "タイマー完了時に視覚的・音声的アラートを受け取れます。さまざまな通知音から選択するか、サイレント動作を選ぶこともできます。",
  
  "aboutFeatureEffectsTitle": "視覚効果",
  "aboutFeatureEffectsText": "サークル、ウェーブ、パルス、パーティクル、グラデーションなど、さまざまな視覚効果でタイマーをカスタマイズできます。不透明度、速度、色を好みに合わせて調整可能です。",
  
  "aboutFeatureShortcutsTitle": "キーボードショートカット",
  "aboutFeatureShortcutsText": "開始、一時停止、停止、リセット機能のキーボードショートカットで効率的にタイマーを操作できます。",
  
  "aboutFeatureLanguagesTitle": "多言語サポート",
  "aboutFeatureLanguagesText": "好みの言語でアプリを使用できます。現在、英語、中国語、スペイン語、フランス語、日本語に対応しています。",
  
  "aboutFeatureDarkModeTitle": "ダークモード",
  "aboutFeatureDarkModeText": "明るいテーマと暗いテーマを切り替えて、目の疲れを軽減し、OLEDデバイスのバッテリー寿命を延ばせます。",
  
  "aboutHowToUseTitle": "使い方",
  "aboutHowToCreateTitle": "タイマーの作成",
  "aboutHowToCreateText": "「タイマーを追加」ボタンをクリックし、名前を入力し、タイマーモード（カウントダウンまたはストップウォッチ）を選択し、時間（カウントダウンの場合）を設定し、視覚効果をカスタマイズします。完了したら「保存」をクリックします。",
  
  "aboutHowToControlTitle": "タイマーの操作",
  "aboutHowToControlText": "コントロールボタンを使用して、タイマーの開始、一時停止、停止、リセットを行います。より良い視認性のために全画面モードに切り替えることもできます。",
  
  "aboutHowToCustomizeTitle": "エフェクトのカスタマイズ",
  "aboutHowToCustomizeText": "タイマーの作成または編集時に、エフェクトタイプを選択し、不透明度、速度、色のコントロールを使用して外観を調整します。",
  
  "aboutHowToManageTitle": "タイマーの管理",
  "aboutHowToManageText": "編集アイコンをクリックして既存のタイマーを変更します。削除アイコンを2回クリックしてタイマーを削除します。すべてのタイマーは自動的に保存され、戻ってきたときに利用できます。",
  
  "aboutProjectTitle": "プロジェクトについて",
  "aboutProjectText": "このプロジェクトは、React、TypeScript、およびアニメーションと状態管理のための様々なライブラリを使用した現代的なウェブアプリケーションとして開発されました。",
  
  "aboutVersionInfo": "バージョン 1.0.0"
}; 